import { render, staticRenderFns } from "./JobSeekersTBD.vue?vue&type=template&id=59728366&scoped=true&"
import script from "./JobSeekersTBD.vue?vue&type=script&lang=js&"
export * from "./JobSeekersTBD.vue?vue&type=script&lang=js&"
import style0 from "./JobSeekersTBD.vue?vue&type=style&index=0&id=59728366&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59728366",
  null
  
)

export default component.exports